
import {fixPageAfterDel} from '@/utils/utils'

import columns from './tableConfig'
import {searchItems} from './searchFormConfig'

let searchCache = {}
import store from '@/store'
import {
  BindTerminal,
  QueryTerminalIndex,
  TerminalCreate,
  TerminalDelete,
  TerminalImport,
  TerminalUpdate,
  UnbindTerminal
} from '@/apis/device'
import { AppCreate, AppDelete, AppIndex, AppResetKey, AppUpdate } from '@/apis/app'
import { GetIdInfoIndex } from '@/apis/idInfo'

const enumsData = store.state.enumsStore.enumsData

const { DeviceType : deviceTypes } = enumsData
export default {
  name: 'IdInfo.Index',
  data() {
    return {
      searchItems,
      searching: false,
      confirmGroupLoading: false,
      deviceTypes,
      columns,
      data: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },


      showAppInfoModal: false,
      showEditModal: false,
      showBindModal: false,
      showImportModal: false,

      target: null,
      deviceStates : [
        {code: 0, name: '正常'},
        {code: 1, name: '禁用'},
        {code: 2, name: '删除'},
      ],
      templateList:[],
    }
  },
  watch: {
    '$route.params.search': async function(search) {
      if (search) {
        this.$refs.searchForm.handlerSearch()
      }
    }
  },
  created() {
    this.$nextTick(async () => {
      const { search } = this.$route.params
      this.$refs.searchForm.handlerSearch()
    })
  },
  methods: {
    // 查询模板
    async getAppIndex(page = 1, searchData) {
      try {
        this.loading = true
        // 确定搜索条件
        searchData = searchData || searchCache
        // 缓存搜索条件
        searchCache = searchData

        const { name, certNo, deviceSn,zfbHotelProjectName, dateTimeRange } = searchData
        let createdAtFrom, createdAtTo
        if (dateTimeRange && dateTimeRange.length) {
          createdAtFrom = dateTimeRange[0].format('YYYY-MM-DD HH:mm:ss')
          createdAtTo = dateTimeRange[1].format('YYYY-MM-DD HH:mm:ss')
        }

        const {collection: data, pageInfo} = await GetIdInfoIndex({
          name, certNo, deviceSn,zfbHotelProjectName,
          createdAtFrom,
          createdAtTo,
          page,
          perPage: this.pagination.pageSize
        })
        this.data = data
        this.pagination.current = page
        this.pagination.total = pageInfo.total
      } catch (error) {
        console.log(error)
      }
      this.loading = this.searching = false
    },
    // 翻页
    handlePageTurn(pagination, filters, sorter) {
      const {current, pageSize} = pagination
      this.pagination.pageSize = pageSize
      this.getAppIndex(current)
    },
    queryTypeName(code){
      console.log(deviceTypes, code)
      return  deviceTypes ? deviceTypes.find(item=>item.code === code).name : ""
    },
  }
}
